import * as React from 'react';
import { IconProps } from './IconProps';

const GoogleTagManager: React.FC<IconProps> = ({ size, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} preserveAspectRatio="xMidYMid" viewBox="0 0 256 256" data-testid="google tag manager-icon">
    <path fill={color || '#8AB4F8'} d="m150.262 245.516-44.437-43.33 95.433-97.455 46.007 45.09z" />
    <path
      fill={color || '#4285F4'}
      d="M150.45 53.938 106.176 8.731 9.36 104.629c-12.48 12.48-12.48 32.713 0 45.207l95.36 95.986 45.09-42.182-72.654-76.407 73.295-73.295Z"
    />
    <path
      fill={color || '#8AB4F8'}
      d="m246.625 105.37-96-96c-12.494-12.494-32.756-12.494-45.25 0-12.495 12.495-12.495 32.757 0 45.252l96 96c12.494 12.494 32.756 12.494 45.25 0 12.495-12.495 12.495-32.757 0-45.251Z"
    />
    <circle cx={127.265} cy={224.731} r={31.273} fill={color || '#246FDB'} />
  </svg>
);
export default GoogleTagManager;
